export const GET_ACCESS_RESTRICTION = 'GET_ACCESS_RESTRICTION';